import { render, staticRenderFns } from "./EPaperManageView.vue?vue&type=template&id=36f9e367&scoped=true&"
import script from "./EPaperManageView.vue?vue&type=script&lang=js&"
export * from "./EPaperManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9e367",
  null
  
)

export default component.exports